<template>
  <section class="nuestro-menu">
    <h2 class="h-blanco"><span>Nuestro delicioso</span>Menú</h2>
    <div class="contenedor grid-menu">
      <section class="menu cafe">
        <h3>Café</h3>
        <ul>
          <li>
            <p>Café Latte <span>Café Espresso con leche caliente evaporada</span> </p>
            <p class="precio">$25</p>
          </li>
          <li>
            <p>Café Mocha <span>Espresso con crema batida</span> </p>
            <p class="precio">$30</p>
          </li>
          <li>
            <p>Café Americano <span>Café Negro</span> </p>
            <p class="precio">$30</p>
          </li>
          <li>
            <p>Capuccino<span>Espresso con una capa suave de espuma</span> </p>
            <p class="precio">$25</p>
          </li>
          <li>
            <p>Café Mocha Frio<span>Espresso, dulce con mocha y leche.</span> </p>
            <p class="precio">$29</p>
          </li>
          <li>
            <p>Mocha Frio Quemado<span>Espresso, hielo, con azucar quemada y mantequilla.</span> </p>
            <p class="precio">$35</p>
          </li>
          <li>
            <p>Latte con Caramelo<span>Espresso, leche y caramelo.</span> </p>
            <p class="precio">$39</p>
          </li>
        </ul>
      </section>
      <section class="menu comida">
        <h3>Comida</h3>
        <ul>
          <li>
            <p>Baguette de Pollo<span>Delicioso Baguette con pollo a la plancha</span> </p>
            <p class="precio">$45</p>
          </li>
          <li>
            <p>Baguette Pollo y Queso<span>Baguette combinado con Pollo y Queso Manchego</span> </p>
            <p class="precio">$50</p>
          </li>
          <li>
            <p>Baguette con Tocino<span>Baguette con especias y verduras, además de tocino</span> </p>
            <p class="precio">$50</p>
          </li>
          <li>
            <p>Baguette de Jamón<span>Delicioso baguette con jamón y especias</span> </p>
            <p class="precio">$65</p>
          </li>
          <li>
            <p>Baguette con Jamón, Queso y Tocino<span>El especial de la casa</span> </p>
            <p class="precio">$69</p>
          </li>
          <li>
            <p>Sandwich de Pollo<span>Delicioso sandwich con Pollo y especias</span> </p>
            <p class="precio">$65</p>
          </li>
          <li>
            <p>Sandwich de Jamón y queso<span>Queso Amarillo con Jamón y Queso</span> </p>
            <p class="precio">$59</p>
          </li>
        </ul>
      </section>
    </div>
  </section>
</template>

<style scoped>
.nuestro-menu {
  background-image: url(../../assets/img/menu_arriba.svg), url(../../assets/img/menu_abajo.svg), linear-gradient(to top, #5e311e, #5e311e);
  background-repeat: no-repeat;
  background-position: center 5rem, center 100%, 100%;
  background-size: 130%;
  padding: 15rem 5rem;
}
@media (min-width: 768px) {
  .nuestro-menu {
    padding: 15rem 0;
    background-size: 90%, 90%, 100%;
  }
}
@media (min-width: 1024px) {
  .nuestro-menu {
    background-size: 50%, 50%, 100%;
  }
}

.menu h3 {
  color: #fff;
}
.menu li {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.menu li p {
  font-weight: 700;
  color: #fff;
  line-height: 1.5;
}
.menu li p span {
  color: #c39c63;
  display: block;
}
.menu li .precio {
  color: #fff;
  font-weight: 900;
  font-size: 3rem;
}

@media (min-width: 768px) {
  .grid-menu {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 4rem;
  }
}
</style>